import React from 'react';
import { Skeleton } from '../../ui/Skeleton';
import { Card, CardContent } from '../../ui/Card';

const TicketCardSkeleton: React.FC = () => (
  <Card>
    <CardContent className="p-6">
      <div className="flex items-start justify-between">
        <div className="flex-1 space-y-3">
          {/* Ticket number + status badge */}
          <div className="flex items-center gap-3">
            <Skeleton className="h-6 w-32" />
            <Skeleton className="h-5 w-20 rounded-full" />
          </div>
          {/* Meta info lines */}
          <div className="space-y-2">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-32" />
          </div>
          {/* Message preview */}
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
        {/* Replies indicator */}
        <div className="ml-4">
          <Skeleton className="h-4 w-16" />
        </div>
      </div>
    </CardContent>
  </Card>
);

interface TicketListSkeletonProps {
  count?: number;
}

const TicketListSkeleton: React.FC<TicketListSkeletonProps> = ({ count = 5 }) => (
  <div className="space-y-4">
    {Array.from({ length: count }).map((_, i) => (
      <TicketCardSkeleton key={i} />
    ))}
  </div>
);

export { TicketCardSkeleton, TicketListSkeleton };
